import React, { useEffect, useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';
import AdminLayout from './AdminLayout';
import supabase from '../../supabase/supabase';

const { FiPlus, FiTrash2, FiEdit2, FiSave, FiX, FiInbox, FiTruck } = FiIcons;

const SRI_LANKA_PROVINCES = [
  'Central',
  'Eastern',
  'North Central',
  'Northern',
  'North Western',
  'Sabaragamuwa',
  'Southern',
  'Uva',
  'Western'
];

function AdminShipping() {
  const [rates, setRates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editing, setEditing] = useState(null);
  const [showAdd, setShowAdd] = useState(false);
  const [form, setForm] = useState({ district: '', province: '', rate: '' });

  const load = async () => {
    setLoading(true);
    const { data } = await supabase.from('shipping_rates_1750000002').select('*').order('district');
    setRates(data || []);
    setLoading(false);
  };

  useEffect(() => { load(); }, []);

  const addRate = async () => {
    if (!form.district || !form.rate) return;
    await supabase.from('shipping_rates_1750000002').insert({
      district: form.district,
      province: form.province || form.district,
      rate: Number(form.rate),
      active: true
    });
    setForm({ district: '', province: '', rate: '' });
    setShowAdd(false);
    await load();
  };

  const updateRate = async (id, newRate) => {
    await supabase.from('shipping_rates_1750000002').update({ rate: Number(newRate) }).eq('id', id);
    setEditing(null);
    await load();
  };

  const deleteRate = async (id) => {
    if (!confirm('Delete this shipping rate?')) return;
    await supabase.from('shipping_rates_1750000002').delete().eq('id', id);
    setRates((prev) => prev.filter((r) => r.id !== id));
  };

  const toggleActive = async (rate) => {
    const active = !rate.active;
    await supabase.from('shipping_rates_1750000002').update({ active }).eq('id', rate.id);
    setRates((prev) => prev.map((r) => r.id === rate.id ? { ...r, active } : r));
  };

  return (
    <AdminLayout>
      <div className="admin-page-header">
        <div><h1>Shipping</h1><p>Manage shipping rates by province across Sri Lanka</p></div>
        <div className="admin-header-actions">
          <button className="admin-btn primary" onClick={() => setShowAdd(true)}>
            <SafeIcon icon={FiPlus} /> Add Province
          </button>
        </div>
      </div>

      <div className="admin-card">
        {loading ? (
          <div className="admin-loading">Loading…</div>
        ) : rates.length === 0 ? (
          <div className="admin-empty"><SafeIcon icon={FiInbox} /><p>No shipping rates configured</p></div>
        ) : (
          <div className="admin-table-wrap">
            <table className="admin-table">
              <thead>
                <tr><th>Province</th><th>Rate (Rs.)</th><th>Status</th><th>Actions</th></tr>
              </thead>
              <tbody>
                {rates.map((rate) => (
                  <tr key={rate.id}>
                    <td><strong>{rate.province || rate.district}</strong></td>
                    <td>
                      {editing === rate.id ? (
                        <input type="number" defaultValue={rate.rate} className="admin-inline-input"
                          onBlur={(e) => updateRate(rate.id, e.target.value)}
                          onKeyDown={(e) => e.key === 'Enter' && updateRate(rate.id, e.target.value)}
                          autoFocus
                        />
                      ) : (
                        <span>Rs. {Number(rate.rate).toLocaleString()}</span>
                      )}
                    </td>
                    <td>
                      <button className={`admin-action-btn ${rate.active ? 'primary' : 'danger'}`} onClick={() => toggleActive(rate)}>
                        {rate.active ? 'Active' : 'Disabled'}
                      </button>
                    </td>
                    <td>
                      <div className="admin-row-actions">
                        <button className="admin-icon-btn" onClick={() => setEditing(rate.id)} title="Edit"><SafeIcon icon={FiEdit2} /></button>
                        <button className="admin-icon-btn danger" onClick={() => deleteRate(rate.id)} title="Delete"><SafeIcon icon={FiTrash2} /></button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {showAdd && (
        <div className="admin-modal-overlay" onClick={() => setShowAdd(false)}>
          <div className="admin-modal admin-modal-sm" onClick={(e) => e.stopPropagation()}>
            <div className="admin-modal-header">
              <h2>Add Shipping Province</h2>
              <button className="admin-icon-btn" onClick={() => setShowAdd(false)}><SafeIcon icon={FiX} /></button>
            </div>
            <div className="admin-modal-body">
              <div className="editor-field">
                <label>Province Name</label>
                <select value={form.district} onChange={(e) => setForm((f) => ({ ...f, district: e.target.value, province: e.target.value }))}>
                  <option value="">Select province…</option>
                  {SRI_LANKA_PROVINCES.map((p) => (
                    <option key={p} value={p}>{p}</option>
                  ))}
                </select>
              </div>
              <div className="editor-field">
                <label>Shipping Rate (Rs.)</label>
                <input type="number" value={form.rate} onChange={(e) => setForm((f) => ({ ...f, rate: e.target.value }))} placeholder="e.g. 100" />
              </div>
            </div>
            <div className="admin-modal-footer">
              <button className="admin-btn secondary" onClick={() => setShowAdd(false)}>Cancel</button>
              <button className="admin-btn primary" onClick={addRate}><SafeIcon icon={FiSave} /> Add</button>
            </div>
          </div>
        </div>
      )}
    </AdminLayout>
  );
}

export default AdminShipping;